import React from 'react'
import { ICharacterItem } from '../../../../../../../../../../api/types/character'
import { useInvalidatingMutation } from '../../../../../../../../../../hooks/useInvalidatingMutation'
import { AxiosResponse } from 'axios'
import { IUseItem } from '../../../../../../../../../../api/types/item'
import { mutationUseCharacterItem } from '../../../../../../../../../../api/mutations'
import {
  characterInventoryQueryKey,
  characterQueryKey,
  gameCharsQueryKey,
} from '../../../../../../../../../../api/queries'
import { ActionIconButton } from '../../../../../../../../../../components/ActionIconButton/ActionIconButton'
import { Tooltip } from '@mui/material'
import SettingsSuggestIcon from '@mui/icons-material/SettingsSuggest'
import { ConfirmationDialog } from '../../../../../../../../../../components/ConfirmationDialog/ConfirmationDialog'

export const CharacterUseItem: React.FC<{
  character_item: ICharacterItem
  game_id: number
}> = ({ character_item, game_id }) => {
  const { mutate, isLoading } = useInvalidatingMutation<AxiosResponse, IUseItem>(
    item => mutationUseCharacterItem(item),
    [
      characterInventoryQueryKey(character_item.character_id),
      gameCharsQueryKey(game_id),
      characterQueryKey(character_item.character_id),
    ]
  )

  return (
    <>
      {(character_item.item.consumable || character_item.charges > 0) && (
        <ConfirmationDialog
          body={
            <div>
              {'Użyć '}
              <strong>{character_item.item.name}</strong>
              {'?'}
            </div>
          }
        >
          {(confirm: any) => (
            <ActionIconButton disabled={isLoading}>
              <Tooltip title="Użyj">
                <SettingsSuggestIcon
                  onClick={confirm(
                    (e: any) => () =>
                      new Promise(r => {
                        mutate({
                          game_id: game_id,
                          character_id: character_item.character_id,
                          character_item_id: character_item.id,
                        })
                        return r('ok')
                      })
                  )}
                />
              </Tooltip>
            </ActionIconButton>
          )}
        </ConfirmationDialog>
      )}
    </>
  )
}
